import React, { useState, useContext, useEffect } from 'react';
import styles from 'styles/preview.module.scss';
import { PreviewProvider } from 'context/PreviewContext';
import { Spinner, Cart, Icon } from 'components';
import UserContext from 'context/UserContext';
import ShopContext from 'context/ShopContext';
import Axios from 'axios';
import { NEW_CAMPAIGN_INITIAL_STATE } from 'lib/globals';
import { API } from 'aws-amplify';
import classNames from 'lib/classNames';
import { fakePreviewProducts } from './cart/Utils';
import { default as StickyCart } from './stickyCart';
const cache = {};

const Preview = ({ children, openByDefault, noCampaign }) => {
    const [collapsed, setCollapsed] = useState(!openByDefault);
    const [campaignsFilter, setCampaignsFilter] = useState([]);
    const [compareAtMap, setCompareAtMap] = useState({});
    const [preview_active_campaign, setCampaign] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [campaigns, setCampaigns] = useState(null);
    const [loading, setLoading] = useState(false);
    const [previewError, setPreviewError] = useState('');
    const [lastCampaign, setLastCampaign] = useState(null);
    const [cartIsEmpty, setCartIsEmpty] = useState(false);
    const [autoDiscount, setAutoDiscount] = useState(false);
    const [giftCurrentPreview, setGiftCurrentPreview] = useState('before');
    const [isStickyActVariantFocused, setIsStickyActVariantFocused] = useState(false);
    const [checkoutButtonLoadingEdit, setCheckoutButtonLoadingEdit] = useState(false);
    const [comfirmOrderButtonLoadingEdit, setComfirmOrderButtonLoadingEdit] = useState(false);
    const [showATUAfterText, setShowATUAfterText] = useState(false);
    const [editingProductDetails, setEditingProductDetails] = useState(false);
    const [product, setProduct] = useState(null);

    const [orderCodForm, setOrderCodForm] = useState({});
    const [isCodFormSubmitted, setIsCodFormSubmitted] = useState(false);

    const [campaign_preview_types, setCampaign_preview_types] = useState([
        // 'bundles',
        // 'add_to_unlock',
        // 'one_check_up_sell',
        //
    ]);
    const {
        attributes: { website }
    } = useContext(UserContext);
    const {
        state: { settings, money_format, currency },
        AppLocalStorage
    } = useContext(ShopContext);
    const previewCampaign = (campaign, openPreview = true) => {
        // if (!collapsed && campaign == preview_active_campaign) setCollapsed(true);
        // else {
        // 	setCampaign(campaign);
        // }
        // console.log(campaign.settings.add_to_unlock.goals[0].gift.products[0]);
        // debugger;
        setCampaign(campaign);
        if (openPreview) setCollapsed(false);
    };
    const mergeCompareAt = (data) => {
        setCompareAtMap(Object.assign({}, compareAtMap, data));
    };

    const PREVIEW_CAN_RENDER_ONLY_WITH_CAMPAIGN = !noCampaign && !!campaigns && !!settings;
    const PREVIEW_CAN_RENDER_WITHOUT_CAMPAIGN = !!noCampaign && !!settings;
    const CAN_RENDER_CART =
        !loading &&
        (!!cartItems.length || !!cartIsEmpty) &&
        (!!PREVIEW_CAN_RENDER_ONLY_WITH_CAMPAIGN || !!PREVIEW_CAN_RENDER_WITHOUT_CAMPAIGN);

    const isStickyPreview = window.location.pathname === '/sticky';

    useEffect(() => {
        const generateFakeCartItems = async (campaign) => {
            setLoading(true);
            setLastCampaign(campaign);
            let queryStringParameters;
            let productGetter;
            if (!campaign || campaign.target.type === 'all_products') {
                queryStringParameters = {};
            } else if (
                campaign.target.type === 'specific_products' &&
                campaign.target.selected?.length
            ) {
                queryStringParameters = { handle: campaign.target.selected[0].handle };
            } else if (
                campaign.target.type === 'specific_collections' &&
                campaign.target.selected?.length
            ) {
                // console.log(campaign.target.selected)
                queryStringParameters = {
                    collection_id: campaign.target.selected[0].id
                };
            }
            if (queryStringParameters || !campaign.target.selected?.length) {
                let product = queryStringParameters
                    ? await (async () => {
                          try {
                              const key = JSON.stringify(queryStringParameters);
                              if (cache[key]) return cache[key];
                              const data = await API.get('API_GATEWAY_NEW', '/products', {
                                  queryStringParameters: { limit: 5, ...queryStringParameters }
                              });
                              cache[key] =
                                  data.products.find(
                                      (prd) =>
                                          prd.variants.every((v) => Number(v.price) > 0) &&
                                          ((prd.variants[0].featured_image &&
                                              prd.variants[0].featured_image?.src) ||
                                              (prd.images?.length
                                                  ? prd.images[0].src
                                                  : 'https://cdn.shopify.com/s/files/1/0459/2081/3221/t/4/assets/product-placeholder.png?v=1662386189'))
                                  ) || data.products[0];
                              return cache[key];
                          } catch (_error) {
                              return undefined;
                          }
                      })()
                    : fakePreviewProducts('20.00', 5)[0];
                if (product === undefined) product = fakePreviewProducts('20.00', 5)[0];
                if (!product) return setPreviewError('Sorry, there are no products to preview');
                setProduct(product);
                const { variants, title, images } = product;
                const variant = variants[0];
                const image =
                    variant.featured_image?.src || product.images?.length
                        ? product.images[0].src
                        : 'https://cdn.shopify.com/s/files/1/0459/2081/3221/t/4/assets/product-placeholder.png?v=1662386189';
                const price = parseFloat((parseFloat(variant.price) * 100).toFixed(0));
                setCartItems([
                    {
                        ...variant,
                        price,
                        product_title: title,
                        image,
                        discounts: autoDiscount
                            ? [
                                  {
                                      title: '10% OFF',
                                      amount: price / 10
                                  }
                              ]
                            : [],
                        line_level_discount_allocations: [
                            {
                                discount_application: {
                                    type: 'automatic'
                                }
                            }
                        ],
                        discounted_price: autoDiscount ? price - price / 10 : price,
                        quantity: 1,
                        variant_id: variant.id
                    }
                ]);
                setCompareAtMap(
                    settings.count_compare_at
                        ? {
                              [variant.id]: variant.compare_at_price
                                  ? Number(variant.compare_at_price) * 100
                                  : undefined
                          }
                        : {}
                );
                if (campaign) {
                    setCampaigns({
                        [variant.product_id]: [
                            {
                                type: campaign.settings.type,
                                [campaign.settings.type]: campaign.settings[campaign.settings.type],
                                multi_one_check_upsell:
                                    campaign.settings.type === 'one_check_up_sell'
                                        ? campaign.settings.multi_one_check_upsell
                                        : undefined
                            }
                        ]
                    });
                }
                setLoading(false);
            }
        };

        if (!lastCampaign || !cartItems || lastCampaign.target !== preview_active_campaign.target) {
            generateFakeCartItems(preview_active_campaign);
        } else if (preview_active_campaign && cartItems.length) {
            setCampaigns({
                [cartItems[0].product_id]: [
                    {
                        type: preview_active_campaign.settings.type,
                        [preview_active_campaign.settings.type]:
                            preview_active_campaign.settings[preview_active_campaign.settings.type],
                        multi_one_check_upsell:
                            preview_active_campaign.settings.type === 'one_check_up_sell'
                                ? preview_active_campaign.settings.multi_one_check_upsell
                                : undefined
                    }
                ]
            });
        }
    }, [preview_active_campaign, settings.count_compare_at, autoDiscount]);

    useEffect(() => {
        if (noCampaign && Object.keys(cartItems).length) {
            const {
                modules: { checkout_button },
                theme: { primary, secondary, background },
                font: { color: font_color }
            } = settings;
            const [{ product_id }] = cartItems;
            const fakeCampaigns = campaign_preview_types.map((type) =>
                NEW_CAMPAIGN_INITIAL_STATE(
                    { checkout_button, primary, secondary, font_color, background, type },
                    settings.default_language,
                    currency
                )
            );
            setCampaigns({
                [product_id]: fakeCampaigns.map(({ settings }) => ({
                    type: settings.type,
                    [settings.type]: settings[settings.type]
                }))
            });
        }
    }, [cartItems, settings, campaign_preview_types]);

    const getSettings = () => {
        if (!preview_active_campaign) {
            return {
                ...settings,
                money_format
            };
        }
        const campaignModules = preview_active_campaign.settings.modules;
        return {
            ...settings,
            money_format,
            modules: {
                ...campaignModules,
                checkout_button: settings.modules.checkout_button,
                order_note: campaignModules?.order_note || settings.modules.order_note,
                order:
                    campaignModules.order.indexOf('order_note') === -1
                        ? [...campaignModules.order, 'order_note']
                        : campaignModules.order
            }
        };
    };

    return (
        <PreviewProvider
            value={{
                collapsed,
                setCollapsed,
                setCartIsEmpty,
                setAutoDiscount,
                setGiftCurrentPreview,
                isStickyActVariantFocused,
                setIsStickyActVariantFocused,
                setCheckoutButtonLoadingEdit,
                setComfirmOrderButtonLoadingEdit,
                setShowATUAfterText,
                editingProductDetails,
                setEditingProductDetails,
                previewCampaign,
                preview_active_campaign,
                campaign_preview_types: {
                    get: campaign_preview_types,
                    set: setCampaign_preview_types
                }
            }}
        >
            <div className={styles.wrapper}>
                <div className={styles.content}>{children}</div>
                <div
                    className={styles.preview}
                    data-collapsed={collapsed}
                    data-curved={settings?.curved}
                    id="monster_preview"
                    style={{ background: isStickyPreview ? '#f6f7fb' : '' }}
                >
                    {previewError && (
                        <div className={classNames('h-full flex-center flex-col p-3')}>
                            <Icon
                                icon="exclamation-triangle"
                                className="text-red-500 mb-2"
                                size="2x"
                            />
                            <p className={classNames('text-red-500 text-sm')}>{previewError}</p>
                        </div>
                    )}
                    {!CAN_RENDER_CART && !previewError && <Spinner text="Fetching product" />}
                    {CAN_RENDER_CART && !previewError && !isStickyPreview && (
                        <Cart
                            campaigns={campaigns}
                            shop_settings={getSettings()}
                            shop_url={website}
                            compareAtMap={compareAtMap}
                            cart_items={cartIsEmpty ? [] : cartItems}
                            giftCurrentPreview={giftCurrentPreview}
                            isPreview={true}
                            cart_currency={currency}
                            setCompareAtMap={mergeCompareAt}
                            showCheckoutLoading={checkoutButtonLoadingEdit}
                            showComfirmOrderLoading={comfirmOrderButtonLoadingEdit}
                            showATUAfterText={showATUAfterText}
                            {...{
                                orderCodForm,
                                setOrderCodForm,
                                isCodFormSubmitted,
                                setIsCodFormSubmitted
                            }}
                            forcePreview={
                                editingProductDetails && product
                                    ? { ...product, showAddCartButton: true }
                                    : null
                            }
                            AppLocalStorage={AppLocalStorage}
                        />
                    )}
                    {product && !previewError && isStickyPreview && (
                        <div className={styles.mobileContainar}>
                            <StickyCart
                                settings={settings}
                                device="mobile"
                                product={product}
                                isPreview={true}
                            />
                        </div>
                    )}
                </div>

                {product && !previewError && isStickyPreview && (
                    <StickyCart
                        settings={settings}
                        money_format={money_format}
                        device="desktop"
                        product={product}
                        isPreview={true}
                    />
                )}
            </div>
        </PreviewProvider>
    );
};

export default Preview;
